import { PanelItem } from '../panel-item.class';
import { Size } from '../../../types';

export const getCutoutSizeCfn = (panelItem: PanelItem): Size => {
	const panelHeight = panelItem.refMap?.panel?.size.height ?? null;
	if (panelHeight === null) return panelItem.item.cutout;

	const countertopThickness = panelItem.refMap?.island?.getCountertop()?.material.thickness ?? 0;

	const cutoutSize: Size = {
		width: panelItem.item.cutout.width,
		height: panelItem.isFullHeightAppliance
			? panelHeight
			: panelItem.item.distanceBelowCountertop
					? panelItem.item.distanceBelowCountertop - countertopThickness
					: panelItem.item.cutout.height,
		depth: panelItem.item.cutout.depth
	};

	return cutoutSize;
};
